import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=2f27dd1a&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=2f27dd1a&prod&lang=sass"
import style1 from "./Drawer.vue?vue&type=style&index=1&id=2f27dd1a&prod&lang=sass&scoped=true"
import style2 from "./Drawer.vue?vue&type=style&index=2&id=2f27dd1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27dd1a",
  null
  
)

export default component.exports